<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img
        src="@/assets/images/pages/graphic-3.png"
        alt="Already logedin"
        class="mx-auto mb-4 max-w-full"
      />
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
        قبلا وارد شده اید!
      </h1>
      <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse">
        شما قبلا وارد شده اید. برای خروج یا مشاهده پنل کاربری از دکمه‌های زیر استفاده کنید.
      </p>
      <div class="vx-row mb-4">
        <div class="vx-col">
          <vs-button size="large" to="/" icon-pack="feather" icon="icon-home"
            >خانه</vs-button
          >
        </div>
        <div class="vx-col">
          <vs-button size="large" @click="logout">خروج</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import ProfileDropDown from "@/layouts/components/navbar/components/ProfileDropDown.vue";
export default {
  components: {
    // ProfileDropDown,
  },
  methods: {
    logout() {
      //   var newFunc = ProfileDropDown.methods.logout.bind(this);
      // newFunc();
      this.$store.dispatch("auth/Logout");
      this.$router.push("/pages/login");
    },
  },
};
</script>
